import { Injectable, Component } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { CookieUtils } from './cookieutils';

import { GetAccountByUsernameService } from '../service/get-account-by-username.service';

@Injectable()
export class AuthUtils {
	private cookieUtils: CookieUtils;
    private GetAccountByUsernameService: GetAccountByUsernameService;

    private serviceInvoked: boolean;
    private currentUser: any;

	constructor(cookieUtils:CookieUtils, GetAccountByUsernameService:GetAccountByUsernameService) {
		this.cookieUtils = cookieUtils;
        this.GetAccountByUsernameService = GetAccountByUsernameService;

        this.serviceInvoked = false;
        this.currentUser = null;
	}

    private isAdministratorRolePresent() {
        let roles: Array<string> = this.currentUser.roles;

        let foundRole: boolean = false;
        if (roles) {
            roles.forEach(function(role) {
                if (role && role.name && role.name !== "Login") {
                    foundRole = true;
                }
            }.bind(this));
        }

        return foundRole;
    }

    public isLoggedInAsAdministrator() {
        let obs: Observable<any> = Observable.create(
            observer => {
                let obs = this.getCurrentUser().subscribe(
                    res => {
                        if ( res !== null ) {
                            observer.next(this.isAdministratorRolePresent());
                            observer.complete();
                        } else {
                            observer.next(false);
                            observer.complete();
                        }
                    }
                );
            }
        ).share();

        return obs;
    }

    public getCurrentUser() {
        let obs:Observable<any> = Observable.create(
            observer => {
                if (!this.serviceInvoked) {
                    if (this.isLoggedIn()) {

                        let username: string = atob(decodeURIComponent(this.cookieUtils.getCookie("LMBA"))).split(":")[0];
                        let requestObj = {
                            username: username
                        };

                        this.GetAccountByUsernameService.get(requestObj).subscribe(
                            res => {
                                this.serviceInvoked = true;
                                this.currentUser = res;

                                observer.next(res);
                                observer.complete();
                            }
                        );
                    } else {
                        observer.next(null);
                        observer.complete();
                    }
                } else {
                    observer.next(this.currentUser);
                    observer.complete();
                }
            }
        ).share();

        return obs;
    }

    public isLoggedIn() {
		let cookieVal: string = this.cookieUtils.getCookie("LMBA");
        if (cookieVal) {
            var parts = atob(decodeURIComponent(cookieVal)).split(":");
            return (parts.length === 2);
        }

        return false;
    }

}
